import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ConfirmActionButton } from '~/components/overlays';
import { useArchiveQuote } from '~/api';
import { sellerLabel } from '~/utils';
import {
  buyerQuoteActions,
  type QuoteWithRequestStatus,
} from './quoteNegotiation';
import type { QuoteSeller } from './splitAwardGridTypes';

export function ArchiveQuoteButton({
  quote,
}: Readonly<{ quote: QuoteSeller & QuoteWithRequestStatus }>) {
  const { t } = useTranslation('rfq-view');
  const { mutateAsync: archiveQuote, isPending } = useArchiveQuote();

  if (!buyerQuoteActions(quote).archive) {
    return null;
  }

  const sellerName = sellerLabel(quote.sellingOrganization);
  const archiveLabel = t('rfq_view.archive_quote_aria_label', { sellerName });

  return (
    <ConfirmActionButton
      triggerLabel={
        <Trash2
          size={14}
          aria-hidden="true"
          className="text-neut-600 transition-colors group-hover:text-error-700"
        />
      }
      triggerProps={{
        variant: 'ghost-primary',
        className:
          'group focus-visible:ring-2 focus-visible:ring-prim focus-visible:ring-offset-2',
        'aria-label': archiveLabel,
        title: archiveLabel,
      }}
      title={archiveLabel}
      message={t('rfq_view.archive_quote_confirm_message', { sellerName })}
      cancelLabel={t('rfq_view.archive_cancel')}
      confirmLabel={t('rfq_view.archive_quote_confirm')}
      successMessage={t('rfq_view.quote_archived')}
      isPending={isPending}
      onConfirm={() => archiveQuote({ quoteId: quote.id })}
    />
  );
}
